import WorldForm from "@src/components/Forms/Worlds/World"
import { PageHeader } from "@src/components/PageHeader/PageHeader"
import Page from "@src/layout/Page"
import { createWorld } from "@src/services/requests/worlds"

export const WorldNew = () => {

    return <Page>
        <div className="worlds">
            <PageHeader title="New world:" />

            <WorldForm submitFn={createWorld} />
        </div>
    </Page>
}
